import { render, staticRenderFns } from "./home-youtube.vue?vue&type=template&id=849a8eec&scoped=true"
import script from "./home-youtube.vue?vue&type=script&lang=js"
export * from "./home-youtube.vue?vue&type=script&lang=js"
import style0 from "./home-youtube.vue?vue&type=style&index=0&id=849a8eec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "849a8eec",
  null
  
)

export default component.exports